export default {
  getAuth(state) {
    return state.auth;
  },
};
